@if (gridView) {
  <div id="grid-view-container" class="grid-view-container">
    <!------------ Tile ------------>
    @for (tile of filteredTileData; track trackByFn(i, tile); let i = $index) {
      <div
        id="tile_{{ i }}"
        class="tile_{{ getID(tile) }} tile-container"
        [routerLink]="getUrlForTile(tile)"
        queryParamsHandling="merge"
        (click)="openAssignment(tile)"
        >
        <!-- Status Tabs - Upcoming / In Progress / Overdue / Submitted / Evaluated -->
        <status-tabs
          class="status-tabs-component"
          [assignment]="tile"
          [topTab]="true"
        ></status-tabs>
        <!-- Top Section -->
        <section class="top-section">
          <!-- Activity Asset Type -->
          <div class="activity-asset-type-container">
            <img
              class="activity-asset-type-icon icon-33-x-33"
              [src]="getAssignableTypeForIcon(tile)"
              />
            <span
              class="data-value font-size-14px activity-asset-type-title"
              >
              {{ getCapAssignableTypeName(tile) }}
            </span>
          </div>
          <!-- Assignment Titles -->
          <div class="assignment-titles-container">
            <!-- Activity Title -->
            <h3
              class="h2-value font-size-16px activity-title"
              [innerHTML]="getAssignmentName(tile)"
            ></h3>
            <!-- eBook Book Title -->
            @if (tile?.asset?.assetTypeId === assetTypeIds.EBOOK_ACT) {
              <span
                class="sub-title tile-sub-title font-size-12px font-style-italic"
                >
                <span class="sub-title-label">Resource:</span
                  >{{ tile?.asset?.bookName }}
                </span>
              }
              <!-- Activity Info -->
              @if (
                tile?.asset?.page ||
                (tile?.asset?.bookActivityNumber &&
                tile?.asset?.assetTypeId === assetTypeIds.EBOOK_ACT)
                ) {
                <div
                  class="activity-info-container"
                  >
                  <!-- page -->
                  @if (tile?.asset?.page) {
                    <span
                      class="sub-title tile-sub-title font-size-12px font-style-italic"
                      >
                      <span class="sub-title-label">Page: </span>
                      {{ tile?.asset?.page }}
                    </span>
                  }
                  <!-- activity number -->
                  @if (
                    tile?.asset?.bookActivityNumber &&
                    tile?.asset?.assetTypeId === assetTypeIds.EBOOK_ACT
                    ) {
                    <span
                      class="sub-title tile-sub-title font-size-12px font-style-italic"
                      >
                      <span class="sub-title-label">Activity Number: </span>
                      {{ tile?.asset?.bookActivityNumber }}
                    </span>
                  }
                </div>
              }
              <!-- IPA Part -->
              @if (
                tile?.asset?.assetActivityTypeId &&
                tile?.asset?.assetActivityTypeId ===
                assetActivityTypeIds.IPA
                ) {
                <span
                  class="sub-title tile-sub-title font-size-12px font-style-italic"
                  >
                  <span class="sub-title-label"
                    >Part {{ tile?.asset?.categoryOrder }}:</span
                    >
                    {{ tile?.asset?.displayName }}
                  </span>
                }
                <!-- Bundle Activities Count -->
                @if (tile?.asset?.assetTypeId === assetTypeIds.BUNDLE) {
                  <span
                    class="sub-title tile-sub-title font-size-12px font-style-italic"
                    >
                    <span class="sub-title-label">Activities:</span>
                    {{ tile?.asset?.tasks?.length }}
                  </span>
                }
                <!-- Custom Activity Response Type -->
                @if (tile?.asset?.assetTypeId === assetTypeIds.CUSTOM_ACT) {
                  <span
                    class="sub-title tile-sub-title font-size-12px font-style-italic"
                    >
                    <span class="sub-title-label">Response Type:</span>
                    {{
                    getCustomActivityResponseType(tile?.asset?.responseType)
                    }}
                  </span>
                }
              </div>
            </section>
            <section class="bottom-section">
              <!-- Dates -->
              <div
                class="primary-date-container"
                [ngClass]="getDueDateStatus(tile)"
                >
                <!-- Due/Submitted/Evaluated Date -->
                <mat-icon class="tile-icon date-icon">date_range</mat-icon>
                <span class="data-value font-size-12px due-date">
                  {{ getProperDisplayedDate(tile) }}
                </span>
              </div>
              <!-- Activity Time Range -->
              @if (
                isMathWorkspace(tile) ||
                tile?.asset?.assetTypeId == assetTypeIds.READYCHECK
                ) {
                <div
                  class="activity-time-range-container"
                  >
                  <mat-icon
                    [svgIcon]="'time_icon_grey'"
                    class="tile-icon time-icon"
                  ></mat-icon>
                  @if (pacingDataActualAvailable(tile)) {
                    <span
                      class="data-value font-size-12px pacingText"
                      >
                      {{ pacingDataActual(tile) }}
                    </span>
                  }
                  @if (
                    !pacingDataActualAvailable(tile) &&
                    pacingDataEstimateAvailable(tile)
                    ) {
                    <span
                      class="data-value font-size-12px pacingText"
                      >
                      {{ pacingDataEstimate(tile) }}
                    </span>
                  }
                  @if (noPacingDataAvailable(tile)) {
                    <span
                      class="data-value font-size-12px pacingText"
                      >None Set</span
                      >
                    }
                  </div>
                }
                <section class="score-feedback-container">
                  <!-- Score -->
                  @if (tile?.asset?.assetTypeId !== assetTypeIds.EREADER) {
                    <div
                      class="activity-score-container"
                      >
                      <mat-icon
                        class="tile-icon check-circle"
                        [ngClass]="getCheckCircleColor(tile)"
                        >check_circle_outline</mat-icon
                        >
                        <span class="data-value font-size-12px activity-score">
                          {{ getGrades(tile) }}
                          <!-- submitted late -->
                          @if (tile?.dueStatus === 'submittedLate') {
                            <span
                              class="submittedLate"
                              >
                              (Submitted Late)
                            </span>
                          }
                          <!-- Overdue but Evaluated -->
                          @if (
                            getDueDateStatus(tile) === 'overdueButEvaluated'
                            ) {
                            <span
                              class="overdueButEvaluated"
                              >
                              (Overdue but Evaluated)
                            </span>
                          }
                          <!-- Due Today but Evaluated -->
                          @if (
                            getDueDateStatus(tile) === 'dueTodayEvaluated'
                            ) {
                            <span
                              class="dueTodayButEvaluated"
                              >
                              (Due Today but Evaluated)
                            </span>
                          }
                          <!-- Due This Week but Evaluated -->
                          @if (
                            getDueDateStatus(tile) ===
                            'dueThisWeekEvaluated'
                            ) {
                            <span
                              class="dueTodayButEvaluated"
                              >
                              (Due This Week but Evaluated)
                            </span>
                          }
                        </span>
                      </div>
                    }
                    <!-- Written Feedback from Teacher -->
                    @if (tile?.feedback) {
                      <div class="written-feedback-container">
                        @if (tile?.feedbackUpdatedAt && tile?.readAt) {
                          <mat-icon
                            class="feedback-icon"
                            matTooltip="Teacher Feedback"
                        (click)="
                            openFeedbackDialog(tile);
                            $event.stopPropagation();
                            $event.preventDefault()
                        "
                            svgIcon="written-feedback-grey"
                            >
                          </mat-icon>
                        }
                        @if (tile?.feedbackUpdatedAt && !tile?.readAt) {
                          <mat-icon
                            class="feedback-icon"
                            matTooltip="Unread Teacher Feedback"
                        (click)="
                            openFeedbackDialog(tile);
                            $event.stopPropagation();
                            $event.preventDefault()
                        "
                            svgIcon="written-feedback-green"
                            >
                          </mat-icon>
                        }
                        <span class="cdk-visually-hidden"
                          >Assignment Feedback Icon</span
                          >
                        </div>
                      }
                    </section>
                    <!-- More Info and Launch Buttons -->
                    <div class="more-info-launch-container">
                      <!-- More Info Container -->
                      <div
                        class="more-info-container"
                    (click)="
                        openTileInfoDialog(tile);
                        $event.stopPropagation();
                        $event.preventDefault()
                    "
                        >
                        <mat-icon
                          class="tile-icon more-info-icon"
                          matTooltip="Full Assignment Info"
                          >info</mat-icon
                          >
                          <span class="more-info-text">More Info</span>
                          <span class="cdk-visually-hidden"
                            >More Assignment Info Icon</span
                            >
                          </div>
                          <!-- Launch Button -->
                          <a
                            class="tile-anchor"
                            [routerLink]="getUrlForTile(tile)"
                            queryParamsHandling="merge"
                            (click)="openAssignment(tile)"
                            >
                            <status-launch-buttons
                              class="launch-button-component"
                              [assignment]="tile"
                            ></status-launch-buttons>
                          </a>
                        </div>
                      </section>
                    </div>
                  }
                </div>
              }
              @if (
                gridView && !filteredTileData.length && !listView
                ) {
                <no-search-results
                ></no-search-results>
              }

              <!-- Assignments List View -->
              @if (listView) {
                <mat-accordion id="list-container" class="list-container">
                  <!-- Program Card -->
                  @for (panel of filteredTileData; track panel; let p = $index) {
                    <mat-expansion-panel
                      class="list-assignment"
                      #expPanel
                      (opened)="isSpineImageLoaded = false"
                      [ngClass]="{ left: !(p % 2), right: p % 2 }"
                      >
                      <!-- <pre>{{ teacher-class.teacher-class }} </pre> -->
                      <mat-expansion-panel-header
                        class="assignment-list-expansion-panel-header"
                        collapsedHeight="auto"
                        expandedHeight="auto"
                        >
                        <!-- Status -->
                        <status-tabs
                          class="status-bar"
                          [assignment]="panel"
                          [topTab]="false"
                        ></status-tabs>
                        <!-- Assignment Type -->
                        <div class="assignment-type-container">
                          <img
                            class="activity-assignable-type-icon icon-33-x-33"
                            [src]="getAssignableTypeForIcon(panel)"
                            />
                          <p class="activity-assignable-type-title">
                            {{ getCapAssignableTypeName(panel) }}
                          </p>
                        </div>
                        <!-- Assignment Titles -->
                        <div class="assignment-titles">
                          <!-- Activity Title -->
                          <h3
                            class="h2-value font-size-16px activity-title"
                            [innerHTML]="getAssignmentName(panel)"
                          ></h3>
                          <span style="display: none">{{
                            getAssignmentName(panel)?.length
                          }}</span>
                          <div class="activity-sub-titles">
                            <!-- Book Title -->
                            @if (
                              panel?.asset?.assetTypeId === assetTypeIds.EBOOK_ACT
                              ) {
                              <p
                                class="activity-book-title"
                                >
                                {{ panel?.asset?.bookName }}
                              </p>
                            }
                            <!-- Activity SubTitle -->
                            <!--                    <p-->
                    <!--                        *ngIf="-->
                    <!--                            panel?.asset?.assetTypeId === assetTypeIds.EBOOK_ACT-->
                    <!--                        "-->
                    <!--                        class="activity-sub-title"-->
                    <!--                    >-->
                    <!--                        {{-->
                    <!--                            getActivityTypeName(panel?.asset?.bookActivityType)-->
                    <!--                        }}-->
                    <!--                    </p>-->
                    @if (panel?.asset?.assetTypeId === 'ASSESSMENT') {
<p
                       
                        class="activity-sub-title"
                              >
                              Part {{ panel?.asset?.categoryOrder }}:
                              {{ panel?.asset?.categoryName }}
                            </p>
                          }
                          @if (
                            panel?.asset?.assetTypeId === assetTypeIds.BUNDLE
                            ) {
                            <p
                              class="activity-sub-title"
                              >
                              Activities:
                              {{ panel?.asset?.tasks?.length }}
                            </p>
                          }
                          @if (
                            panel?.asset?.assetTypeId ===
                            assetTypeIds.CUSTOM_ACT
                            ) {
                            <p
                              class="activity-sub-title"
                              >
                              {{
                              getCustomActivityResponseType(
                              panel?.asset.responseType
                              )
                              }}
                            </p>
                          }
                        </div>
                      </div>
                      <!-- Due/Submitted/Evaluated Date -->
                      <div class="dates-container">
                        <p class="due-date" [ngClass]="getDueDateStatus(panel)">
                          {{ getProperDisplayedDate(panel) }}
                        </p>
                      </div>
                      <div class="time-range-score-feedback-container">
                        <!-- Activity Time Range -->
                        @if (
                          isMathWorkspace(panel) ||
                          panel?.asset?.assetTypeId == assetTypeIds.READYCHECK
                          ) {
                          <div
                            class="activity-time-range-container"
                            >
                            <mat-icon
                              [svgIcon]="'time_icon_grey'"
                              class="list-icon time-icon"
                            ></mat-icon>
                            @if (pacingDataActualAvailable(panel)) {
                              <span
                                class="data-value font-size-12px pacingText"
                                >
                                {{ pacingDataActual(panel) }}
                              </span>
                            }
                            @if (
                              !pacingDataActualAvailable(panel) &&
                              pacingDataEstimateAvailable(panel)
                              ) {
                              <span
                                class="data-value font-size-12px pacingText"
                                >
                                {{ pacingDataEstimate(panel) }}
                              </span>
                            }
                            @if (noPacingDataAvailable(panel)) {
                              <span
                                class="data-value font-size-12px pacingText"
                                >None Set</span
                                >
                              }
                            </div>
                          }
                          <!-- Score - All except eReader -->
                          <section class="score-feedback-container">
                            <!-- Score -->
                            @if (
                              panel?.asset?.assetTypeId !== assetTypeIds.EREADER
                              ) {
                              <div
                                class="activity-score-container"
                                >
                                <mat-icon
                                  class="list-icon check-circle"
                                  [ngClass]="getCheckCircleColor(panel)"
                                  >check_circle_outline</mat-icon
                                  >
                                  <span class="data-value font-size-12px activity-score">
                                    {{ getGrades(panel) }}
                                    <!-- submitted late -->
                                    @if (panel?.dueStatus === 'submittedLate') {
                                      <span
                                        class="submittedLate"
                                        >
                                        (Submitted Late)
                                      </span>
                                    }
                                    <!-- Overdue but Evaluated -->
                                    @if (
                                      getDueDateStatus(panel) ===
                                      'overdueButEvaluated'
                                      ) {
                                      <span
                                        class="overdueButEvaluated"
                                        >
                                        (Overdue but Evaluated)
                                      </span>
                                    }
                                    <!-- Due Today but Evaluated -->
                                    @if (
                                      getDueDateStatus(panel) ===
                                      'dueTodayEvaluated'
                                      ) {
                                      <span
                                        class="dueTodayButEvaluated"
                                        >
                                        (Due Today but Evaluated)
                                      </span>
                                    }
                                    <!-- Due This Week but Evaluated -->
                                    @if (
                                      getDueDateStatus(panel) ===
                                      'dueThisWeekEvaluated'
                                      ) {
                                      <span
                                        class="dueTodayButEvaluated"
                                        >
                                        (Due This Week but Evaluated)
                                      </span>
                                    }
                                  </span>
                                </div>
                              }
                              <!-- Written Feedback from Teacher -->
                              @if (panel?.feedback) {
                                <div
                                  class="written-feedback-container"
                                  >
                                  @if (panel?.feedbackUpdatedAt && panel?.readAt) {
                                    <mat-icon
                                      class="feedback-icon"
                                      matTooltip="Teacher Feedback"
                            (click)="
                                openFeedbackDialog(panel);
                                $event.stopPropagation();
                                $event.preventDefault()
                            "
                                      svgIcon="written-feedback-grey"
                                      >
                                    </mat-icon>
                                  }
                                  @if (panel?.feedbackUpdatedAt && !panel?.readAt) {
                                    <mat-icon
                                      class="feedback-icon"
                                      matTooltip="Unread Teacher Feedback"
                            (click)="
                                openFeedbackDialog(panel);
                                $event.stopPropagation();
                                $event.preventDefault()
                            "
                                      svgIcon="written-feedback-green"
                                      >
                                    </mat-icon>
                                  }
                                  <span class="cdk-visually-hidden"
                                    >Assignment Feedback Icon</span
                                    >
                                  </div>
                                }
                              </section>
                            </div>
                            <!-- Launch Button -->
                            <a
                              class="launch-button-anchor-container"
                              [routerLink]="getUrlForTile(panel)"
                              queryParamsHandling="merge"
                              (click)="openAssignment(panel)"
                              >
                              <status-launch-buttons
                                class="launch-button-component"
                                [assignment]="panel"
                              ></status-launch-buttons>
                            </a>
                          </mat-expansion-panel-header>
                          <!-- Main Content -->
                          <ng-template matExpansionPanelContent>
                            @if (expPanel.expanded) {
                              <div
                                class="assignment-list-expansion-panel-body"
                                >
                                <!-- Smaller Screen Header Data -->
                                <div class="smaller-screen-header-data">
                                  <!-- Assignment Type -->
                                  <div class="assignment-type-container">
                                    <mat-icon
                                      class="activity-assignable-type-icon"
                                      [svgIcon]="getAssignableTypeForIcon(panel)"
                                    ></mat-icon>
                                    <p class="activity-assignable-type-title">
                                      {{ getCapAssignableTypeName(panel) }}
                                    </p>
                                  </div>
                                  <h3
                                    class="h2-value font-size-16px activity-title"
                                    [innerHTML]="getAssignmentName(panel)"
                                  ></h3>
                                  <!-- Book Title -->
                                  @if (
                                    panel?.asset?.assetTypeId === assetTypeIds.EBOOK_ACT
                                    ) {
                                    <p
                                      class="activity-book-title"
                                      >
                                      {{ panel?.asset?.bookName }}
                                    </p>
                                  }
                                  <!-- Activity SubTitle -->
                                  @if (
                                    panel?.asset?.assetTypeId === assetTypeIds.EBOOK_ACT
                                    ) {
                                    <p
                                      class="activity-sub-title"
                                      >
                                      {{
                                      getActivityTypeName(panel?.asset?.bookActivityType)
                                      }}
                                    </p>
                                  }
                                  @if (panel?.asset?.assetTypeId === 'ASSESSMENT') {
                                    <p
                                      class="activity-sub-title"
                                      >
                                      Part {{ panel?.asset?.categoryOrder }}:
                                      {{ panel?.asset?.categoryName }}
                                    </p>
                                  }
                                  @if (
                                    panel?.asset?.assetTypeId === assetTypeIds.BUNDLE
                                    ) {
                                    <p
                                      class="activity-sub-title"
                                      >
                                      Activities:
                                      {{ panel?.asset?.tasks?.length }}
                                    </p>
                                  }
                                  @if (
                                    panel?.asset?.assetTypeId ===
                                    assetTypeIds.CUSTOM_ACT
                                    ) {
                                    <p
                                      class="activity-sub-title"
                                      >
                                      {{
                                      getCustomActivityResponseType(
                                      panel?.asset.responseType
                                      )
                                      }}
                                    </p>
                                  }
                                </div>
                                <div
                                  class="meta-and-info-container"
                    [ngClass]="{
                        'meta-and-info-container-list-view-wide-screen':
                            showAssignmentImage(panel)
                    }"
                                  >
                                  <!-- Assigment Meta Data -->
                                  <section class="assignment-meta-data">
                                    <div class="assignment-meta-data-top">
                                      <!-- Book Image - eBook/eReader -->
                                      @if (showAssignmentImage(panel)) {
                                        <div
                                          class="details-image-container"
                                          >
                                          <img
                                            class="spine-img"
                                            [src]="getSpineImage(panel) | async"
                                            [hidden]="!isSpineImageLoaded"
                                            (load)="isSpineImageLoaded = true"
                                    alt="{{
                                        panel?.bookTitle || 'book cover'
                                    }} image"
                                            />
                                        </div>
                                      }
                                      <!-- Attempts Allowed - eBook -->
                                      <!-- Level - eBook, eReader, Perform, Custom, Mastery, Concept Builder, Bundle, Assessment -->
                                      <!-- Unit - eBook, Perform, Custom, Bundle, Assessment -->
                                      <!-- Lesson - eBook, Perform -->
                                      <!-- Page - eBook -->
                                      <!-- Activity Number - eBook -->
                                      <!-- Response Type - Custom -->
                                      <div class="activity-full-info-container">
                                        <!-- activity type -->
                                        @if (
                                          panel?.asset?.assetTypeId ===
                                          assetTypeIds.EBOOK_ACT
                                          ) {
                                          <p
                                            class="activity-type info-value"
                                            >
                                            <span class="info-label"
                                              >Activity Type:
                                            </span>
                                            {{
                                            getActivityTypeName(
                                            panel?.asset?.bookActivityType
                                            )
                                            }}
                                          </p>
                                        }
                                        <!-- Level -->
                                        @if (
                                          panel?.asset?.levelIds &&
                                          panel?.asset?.levelIds.length > 0 &&
                                          !isMathCourse(panel)
                                          ) {
                                          <p
                                            class="level info-value"
                                            >
                                            <span class="info-label">
                                              {{
                                              panel?.asset?.subjectId ===
                                              "COMP-SCI"
                                              ? "Course"
                                              : "Level"
                                              }}@if (multilevel(panel?.asset)) {
                                              <span
                                                >s</span
                                                >
                                                }:
                                              </span>
                                              {{ getLevelName(panel?.asset) }}
                                            </p>
                                          }
                                          <!-- Unit -->
                                          @if (panel?.asset.unit) {
                                            <p
                                              class="unit info-value"
                                              >
                                              <span class="info-label">Unit:</span>
                                              {{ panel?.asset?.unit }}
                                            </p>
                                          }
                                          <!-- page -->
                                          @if (
                                            panel?.asset.page
                                            ) {
                                            <p
                                              class="page info-value"
                                              >
                                              <span class="info-label">Page:</span>
                                              {{ panel?.asset?.page }}
                                            </p>
                                          }
                                          <!-- Lesson -->
                                          @if (
                                            panel?.asset.lesson
                                            ) {
                                            <p
                                              class="lesson info-value"
                                              >
                                              <span class="info-label">Lesson:</span>
                                              {{ panel?.asset?.lesson }}
                                            </p>
                                          }
                                          <!-- activity number -->
                                          @if (
                                            panel?.asset.bookActivityNumber &&
                                            panel?.asset?.assetTypeId ===
                                            assetTypeIds.EBOOK_ACT
                                            ) {
                                            <p
                                              class="activity-number info-value"
                                              >
                                              <span class="info-label"
                                                >Activity Number:
                                              </span>
                                              {{ panel?.asset?.bookActivityNumber }}
                                            </p>
                                          }
                                        </div>
                                      </div>
                                      <!-- Directions - Perform, Custom, Mastery, Concept Builder, Bundle (non-math), Assessment -->
                                      <!-- What This Connects to - Math Bundle -->
                                      <!-- What You'll learn - Math Bundle -->
                                      <div class="assignment-meta-data-bottom">
                                        <!-- Performance Directions -->
                                        @if (
                                          panel?.asset?.assetTypeId ===
                                          assetTypeIds.PERFORM
                                          ) {
                                          <p
                                            class="dialog-item"
                                            >
                                            <performance-directions
                                              [fontSize]="'font-size-medium'"
                                              [assignment]="panel"
                                              [asset]="panel?.asset"
                                    [maxAttempts]="
                                        formatMaxAttempts(panel?.maxAttempts)
                                    "
                                            ></performance-directions>
                                          </p>
                                        }
                                        <!-- Mastery / Non Mastery Workspace Directions -->
                                        @if (
                                          panel?.asset?.assetTypeId ===
                                          assetTypeIds.COG_TUTOR
                                          ) {
                                          <p
                                            class="dialog-item"
                                            >
                                            <cog-tutor-directions
                                              [fontSize]="'font-size-medium'"
                                              [directions]="panel?.asset.description"
                                            ></cog-tutor-directions>
                                          </p>
                                        }
                                        <!-- Custom Activity Directions -->
                                        @if (
                                          panel?.asset?.assetTypeId ===
                                          assetTypeIds.CUSTOM_ACT
                                          ) {
                                          <p
                                            class="dialog-item"
                                            >
                                            <custom-activity-directions
                                              [fontSize]="'font-size-medium'"
                                              [directions]="panel?.asset.description"
                                            ></custom-activity-directions>
                                          </p>
                                        }
                                        <!-- Ready Check Assessment Directions -->
                                        @if (
                                          panel?.asset?.assetTypeId ===
                                          assetTypeIds.READYCHECK
                                          ) {
                                          <p
                                            class="dialog-item"
                                            >
                                            <ready-check-directions
                                              [fontSize]="'font-size-medium'"
                                              [directions]="panel?.asset.description"
                                            ></ready-check-directions>
                                          </p>
                                        }
                                        <!-- Module Directions -->
                                        @if (
                                          panel?.asset?.assetTypeId === 'ASSESSMENT'
                                          ) {
                                          <p
                                            class="dialog-item"
                                            >
                                            <assessment-directions
                                              [fontSize]="'font-size-medium'"
                                    [assessmentDirection]="
                                        panel?.asset.composite.moduleDirection
                                    "
                                            ></assessment-directions>
                                          </p>
                                        }
                                        <!-- Lesson Directions -->
                                        @if (
                                          panel?.asset?.assetTypeId ===
                                          assetTypeIds.BUNDLE
                                          ) {
                                          <p
                                            class="dialog-item"
                                            >
                                            <bundle-directions
                                              [fontSize]="'font-size-medium'"
                                              [subjectId]="panel?.asset?.subjectId"
                                              [directions]="panel?.asset?.description"
                                              [objectives]="panel?.asset?.objectives"
                                            ></bundle-directions>
                                          </p>
                                        }
                                        <!-- Lesson Skills (for Math) -->
                                        @if (
                                          panel?.asset?.assetTypeId ===
                                          assetTypeIds.BUNDLE &&
                                          panel?.asset?.skills &&
                                          panel?.asset?.skills.length > 0
                                          ) {
                                          <div
                                            class="dialog-item"
                                            >
                                            <bundle-skills
                                              [fontSize]="'font-size-medium'"
                                              [skills]="panel?.asset?.skills"
                                            ></bundle-skills>
                                          </div>
                                        }
                                        <!-- Module activities -->
                                        @if (
                                          panel?.asset?.assetActivityTypeId &&
                                          panel?.asset?.assetActivityTypeId ===
                                          assetActivityTypeIds.IPA
                                          ) {
                                          <div
                                            class="activities-content"
                                            >
                                            <p class="activities-label">
                                              {{ panel?.compositeTaskAssignments.length }}
                                              {{
                                              getProperActivityWord(
                                              panel?.compositeTaskAssignments
                                              .length
                                              )
                                              }}
                                              -
                                              {{ getCompletionCount(panel) }}
                                              submitted
                                            </p>
                                            <div class="activities-list">
                                              @for (
                                                createActivity of panel?.asset
                                                .tasks; track trackByFn($index,
                                                createActivity)) {
                                                <div
                                                  class="activity"
                                                  >
                                                  <img
                                                    class="icon-23-x-23 activity-icon"
                                            [ngClass]="{
                                                'activity-icon-completed':
                                                    getCompletedAt(
                                                        createActivity,
                                                        panel
                                                    )
                                            }"
                                            [src]="
                                                getIconName(
                                                    createActivity,
                                                    panel
                                                )
                                            "
                                            [matTooltip]="
                                                createActivity?.displayName
                                            "
                                                    />
                                                  @if (
                                                    getCompletedAt(
                                                    createActivity,
                                                    panel
                                                    )
                                                    ) {
                                                    <mat-icon
                                                      class="icon-23-x-23 activity-check"
                                                      >done</mat-icon
                                                      >
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                          }
                                          <!-- Lesson activities -->
                                          @if (
                                            panel?.asset?.assetTypeId ===
                                            assetTypeIds.BUNDLE &&
                                            panel?.asset?.assetActivityTypeId &&
                                            panel?.asset?.assetActivityTypeId !==
                                            assetActivityTypeIds.IPA
                                            ) {
                                            <div
                                              class="activities-content"
                                              >
                                              <p class="activities-label">
                                                {{ panel?.asset?.tasks?.length }}
                                                {{
                                                getProperActivityWord(
                                                panel?.asset?.tasks?.length
                                                )
                                                }}
                                                -
                                                {{ getCompletionCount(panel) }}
                                                submitted
                                              </p>
                                              <div class="activities-list">
                                                @for (
                                                  lessonActivity of panel?.compositeTaskAssignments; track trackByFn($index,
                                                  lessonActivity)) {
                                                  <div
                                                    class="activity"
                                                    >
                                                    <img
                                                      class="icon-23-x-23 activity-icon"
                                            [ngClass]="{
                                                'activity-icon-completed':
                                                    lessonActivity?.completedAt
                                            }"
                                            [src]="
                                                getIconName(
                                                    lessonActivity,
                                                    panel
                                                )
                                            "
                                            [matTooltip]="
                                                getBundleActivityDisplayName(
                                                    lessonActivity.assetId,
                                                    panel
                                                )
                                            "
                                                      />
                                                    @if (lessonActivity.completedAt) {
                                                      <mat-icon
                                                        class="icon-23-x-23 activity-check"
                                            [matTooltip]="
                                                lessonActivity?.asset
                                                    ?.displayName
                                            "
                                                        >done</mat-icon
                                                        >
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        </section>
                                        <div
                                          class="in-between-line"
                        [ngClass]="{
                            'in-between-line-list-view-wide-screen':
                                showAssignmentImage(panel)
                        }"
                                        ></div>
                                        <!-- Assignment Info -->
                                        <section class="assignment-info">
                                          <!-- Start Date -->
                                          <p class="font-size-medium">
                                            <span class="font-weight-600">Start Date:</span>
                                            {{ formatDateAndTime(panel?.startDate) }}
                                          </p>
                                          <!-- Due Date -->
                                          @if (panel?.dueDate) {
                                            <p
                                              class="font-size-medium"
                                              [ngClass]="getDueDateStatus(panel)"
                                              >
                                              <span class="font-weight-600">Due Date:</span>
                                              {{ formatDateAndTime(panel?.dueDate) }}
                                            </p>
                                          }
                                          <!-- Submitted Date -->
                                          @if (panel?.completedAt) {
                                            <p class="font-size-medium">
                                              <span class="font-weight-600">Submitted:</span>
                                              {{ formatDateAndTime(panel?.completedAt) }}
                                            </p>
                                          }
                                          <!-- Evaluated Date -->
                                          @if (panel?.evaluatedAt) {
                                            <p class="font-size-medium">
                                              <span class="font-weight-600">Evaluated:</span>
                                              {{ formatDateAndTime(panel?.evaluatedAt) }}
                                            </p>
                                          }
                                          <!-- Activity Time Range -->
                                          <!-- pacing - Mastery, Concept Builder -->
                                          <!--                        <div-->
                        <!--                            *ngIf="-->
                        <!--                                isMathWorkspace(panel) ||-->
                        <!--                                panel?.asset?.assetTypeId ==-->
                        <!--                                    assetTypeIds.READYCHECK-->
                        <!--                            "-->
                        <!--                            class="activity-time-range-container"-->
                        <!--                        >-->
                        <!--                            <p class="pacing-p">-->
                        <!--                                <mat-icon-->
                        <!--                                    [svgIcon]="'Time_Icon_White'"-->
                        <!--                                    class="details-icons"-->
                        <!--                                ></mat-icon>-->
                        <!--                                <span-->
                        <!--                                    *ngIf="pacingDataActualAvailable(panel)"-->
                        <!--                                    class="pacingText"-->
                        <!--                                >-->
                        <!--                                    {{ pacingDataActual(panel) }}-->
                        <!--                                </span>-->
                        <!--                                <span-->
                        <!--                                    *ngIf="-->
                        <!--                                        !pacingDataActualAvailable(panel) &&-->
                        <!--                                        pacingDataEstimateAvailable(panel)-->
                        <!--                                    "-->
                        <!--                                    class="pacingText"-->
                        <!--                                >-->
                        <!--                                    {{ pacingDataEstimate(panel) }}-->
                        <!--                                </span>-->
                        <!--                                <span-->
                        <!--                                    *ngIf="noPacingDataAvailable(panel)"-->
                        <!--                                    class="pacingText"-->
                        <!--                                    >None Set</span-->
                        <!--                                >-->
                        <!--                            </p>-->
                        <!--                        </div>-->

                        <!-- Score - All except eReader -->
                        <section class="score-feedback-container">
                            <!-- Score -->
                            @if (
                                    panel?.asset?.assetTypeId !==
                                    assetTypeIds.EREADER
                                ) {
<div
                               
                                class="activity-score-container"
                                    >
                                    <mat-icon
                                      class="list-icon check-circle"
                                      [ngClass]="getCheckCircleColor(panel)"
                                      >check_circle_outline</mat-icon
                                      >
                                      <span
                                        class="data-value font-size-12px activity-score"
                                        >
                                        {{ getGrades(panel) }}
                                        <!-- submitted late -->
                                        @if (
                                          panel?.dueStatus === 'submittedLate'
                                          ) {
                                          <span
                                            class="submittedLate"
                                            >
                                            (Submitted Late)
                                          </span>
                                        }
                                        <!-- Overdue but Evaluated -->
                                        @if (
                                          getDueDateStatus(panel) ===
                                          'overdueButEvaluated'
                                          ) {
                                          <span
                                            class="overdueButEvaluated"
                                            >
                                            (Overdue but Evaluated)
                                          </span>
                                        }
                                      </span>
                                    </div>
                                  }
                                  <!-- Written Feedback from Teacher -->
                                  @if (panel?.feedback) {
                                    <div
                                      class="written-feedback-container"
                                      >
                                      @if (
                                        panel?.feedbackUpdatedAt &&
                                        panel?.readAt
                                        ) {
                                        <mat-icon
                                          class="feedback-icon"
                                          matTooltip="Teacher Feedback"
                                    (click)="
                                        openFeedbackDialog(panel);
                                        $event.stopPropagation();
                                        $event.preventDefault()
                                    "
                                          svgIcon="written-feedback-grey"
                                          >
                                        </mat-icon>
                                      }
                                      @if (
                                        panel?.feedbackUpdatedAt &&
                                        !panel?.readAt
                                        ) {
                                        <mat-icon
                                          class="feedback-icon"
                                          matTooltip="Unread Teacher Feedback"
                                    (click)="
                                        openFeedbackDialog(panel);
                                        $event.stopPropagation();
                                        $event.preventDefault()
                                    "
                                          svgIcon="written-feedback-green"
                                          >
                                        </mat-icon>
                                      }
                                      <span class="cdk-visually-hidden"
                                        >Assignment Feedback Icon</span
                                        >
                                      </div>
                                    }
                                  </section>
                                </section>
                              </div>
                            </div>
                          }
                        </ng-template>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                }
